module.exports = __webpack_public_path__ + "static/media/inter-latin-700-normal.c20425ba.woff";